export default __webpack_public_path__ + "static/media/bg_leafTint_1_lt.161e29d1.png";